import { diningMainPeople } from './index';

const diningMain = () => {

  const pageOutdoorDining = document.getElementById('pageOutdoor-dining');
  if (pageOutdoorDining) {

    let sW = window.innerWidth;
    let sH = window.innerHeight;
    let header = document.querySelector('header.header');
    let secMain = document.getElementById('jsSecMain');

    let main1f = secMain.querySelectorAll('.js-main-1f');
    let main2f = secMain.querySelectorAll('.js-main-2f');
    let peopleBox1f = secMain.querySelectorAll('.js-people-box-1f');
    let peopleBox2f = secMain.querySelectorAll('.js-people-box-2f');

    let mainWrap = secMain.querySelectorAll('.js-main-wrap');
    let ttlWrap = secMain.querySelectorAll('.js-ttl-wrap');
    let arrowBtn = secMain.querySelectorAll('.js-arrow-wrap button');

    let mainGround1f = []
    let mainObject1f1 = []
    let mainObject1f2 = []
    let mainGround2f = []
    let mainObject2f1 = []
    let mainObject2f2 = []


    if (!(sW > 750)) {
      let headerH = header.clientHeight
      secMain.style.height = `${sH - headerH}px`
    }


    const resetMain = (flr) => {

      mainGround1f = [
        main1f[0],
      ]
      mainObject1f1 = [
        main1f[1],
        main1f[2],
        main1f[3],
        main1f[4],
        main1f[5],
        main1f[6],
        main1f[7],
      ]
      mainObject1f2 = [
        main1f[8],
        main1f[9],
        main1f[10],
        main1f[11],
        main1f[12],
        main1f[13],
        main1f[14],
        main1f[15],
      ]

      mainGround2f = [
        main2f[0],
      ]
      mainObject2f1 = [
        main2f[1],
        main2f[2],
        main2f[3],
        main2f[4],
        main2f[5],
      ]
      mainObject2f2 = [
        main2f[6],
        main2f[7],
        main2f[8],
        main2f[9],
      ]


      let mainGround
      let mainObject1
      let mainObject2
      if (flr == '1f') {
        mainGround = mainGround1f
        mainObject1 = mainObject1f1
        mainObject2 = mainObject1f2
      } else if (flr == '2f') {
        mainGround = mainGround2f
        mainObject1 = mainObject2f1
        mainObject2 = mainObject2f2
      }

      gsap.set(mainGround, {
        y: 20,
        opacity: 0,
      });
      gsap.set(mainObject1, {
        y: 20,
        opacity: 0,
      });
      gsap.set(mainObject2, {
        y: 20,
        opacity: 0,
      });
    }
    resetMain('1f')



    let flag = 0;
    const mainAnime = (flr) => {

      let mainGround
      let mainObject1
      let mainObject2
      if (flr == '1f') {
        mainGround = mainGround1f
        mainObject1 = mainObject1f1
        mainObject2 = mainObject1f2
      } else if (flr == '2f') {
        mainGround = mainGround2f
        mainObject1 = mainObject2f1
        mainObject2 = mainObject2f2
      }

      let tl = gsap.timeline()
      tl.to(mainGround, {
        y: 0,
        opacity: 1,
        duration: .5,
        ease: 'Power1.easeInOut',
      })
        .to(mainObject1, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.5,
            each: 0.1,
            from: "random",
          },
        }, '+=0.5')
        .to(mainObject2, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.2,
            each: 0.1,
            from: "random",
          },
          onComplete: () => {
            flag = flag + 1;
            if (flr == '1f') {
              peopleAct('1f')
              if (flag == 1) {
                diningMainPeople('1f')
              }
            } else if (flr == '2f') {
              peopleAct('2f')
              if (flag == 2) {
                diningMainPeople('2f')
              }
            }
            pinAct()
          },
        }, '+=0.5')
    }


    const peopleAct = (flr) => {

      let peopleBox
      if (flr == '1f') {
        peopleBox = peopleBox1f
      } else if (flr == '2f') {
        peopleBox = peopleBox2f
      }

      setTimeout(() => {
        for (let i = 0; i < peopleBox.length; i++) {
          peopleBox[i].classList.add('act')
          // console.log(peopleBox[i]);
        }
      }, 0)
    }

    const peopleRemove = (flr) => {

      let peopleBox
      if (flr == '1f') {
        peopleBox = peopleBox1f
      } else if (flr == '2f') {
        peopleBox = peopleBox2f
      }

      setTimeout(() => {
        for (let i = 0; i < peopleBox.length; i++) {
          peopleBox[i].classList.remove('act')
          // console.log(peopleBox[i]);
        }
      }, 0)
    }


    const pinAct = () => {
      let pin = secMain.querySelectorAll('.js-pin-box');
      pin.forEach(element => {
        element.classList.add('act')
      });
    }

    const pinRemove = () => {
      let pin = secMain.querySelectorAll('.js-pin-box');
      pin.forEach(element => {
        element.classList.remove('act')
      });
    }


    arrowBtn[0].classList.add('act')
    mainWrap[0].classList.add('act')
    ttlWrap[0].classList.add('act')

    arrowBtn.forEach((element, index, array) => {
      element.addEventListener('click', () => {

        // console.log(index);

        for (let i = 0; i < array.length; i++) {
          arrowBtn[i].classList.add('no-click')
          arrowBtn[i].classList.remove('act')
          mainWrap[i].classList.remove('act')
          ttlWrap[i].classList.remove('act')
        }

        pinRemove()

        if (index == 0) {
          resetMain('1f')
          peopleRemove('1f')
          setTimeout(mainAnime, 1000, '1f')
        } else if (index == 1) {
          resetMain('2f')
          peopleRemove('2f')
          setTimeout(mainAnime, 1000, '2f')
        }

        setTimeout(() => {
          arrowBtn[index].classList.add('act')
          mainWrap[index].classList.add('act')
          ttlWrap[index].classList.add('act')
        }, 500)
        setTimeout(() => {
          for (let i = 0; i < array.length; i++) {
            arrowBtn[i].classList.remove('no-click')
          }
        }, 4000)

      });
    });


    setTimeout(mainAnime, 1000, '1f')


    const pinFunc = (() => {
      let pin = secMain.querySelectorAll('.js-pin-box');
      pin.forEach(element => {
        element.addEventListener('mouseover', () => {
          element.classList.add('on')
        });
        element.addEventListener('mouseleave', () => {
          element.classList.remove('on')
        });
      });
    })()


  }
};
export default diningMain;